export enum DefaultsConstants {
  SET_PROCEDURE_DEFAULTS = 'defaults/SET_PROCEDURE_DEFAULTS',
}
